var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPeople(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 180,
    viewBox: "0 0 185 165",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1.222,
    y1: -0.3,
    x2: 0,
    y2: 1.151,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#55a4ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55a4ff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_1356",
    x: 45.999,
    y: 73,
    width: 109,
    height: 107,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#07111a"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1.178,
    y1: -0.304,
    x2: 0.193,
    y2: 0.919,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "Intersection_7",
    x: 0,
    y: 129,
    width: 200,
    height: 131,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#07111a"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6042",
    "data-name": "Rectangle 6042",
    width: 176,
    height: 225,
    rx: 10,
    transform: "translate(732.029 2875.899)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0,
    y1: 0.683,
    x2: 1.242,
    y2: 2.353,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_1356-2",
    x: -36,
    y: 45,
    width: 120,
    height: 118,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#07111a"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Intersection_7-2",
    x: -91,
    y: 114,
    width: 230,
    height: 146,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#07111a"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29783",
    "data-name": "Group 29783",
    transform: "translate(-732.029 -2935.899)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29777",
    "data-name": "Group 29777",
    transform: "translate(738.277 2973.691)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -25.25, -97.79)",
    filter: "url(#Ellipse_1356)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1356-3",
    "data-name": "Ellipse 1356",
    cx: 24.5,
    cy: 23.5,
    rx: 24.5,
    ry: 23.5,
    transform: "translate(71 98)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -25.25, -97.79)",
    filter: "url(#Intersection_7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Intersection_7-3",
    "data-name": "Intersection 7",
    d: "M0,71C0,31.786,31.337,0,70,0s70,31.786,70,71Z",
    transform: "translate(25 154)",
    fill: "url(#linear-gradient-2)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_90",
    "data-name": "Mask Group 90",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29776",
    "data-name": "Group 29776",
    transform: "translate(647.029 2946)",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 66, -70.1)",
    filter: "url(#Ellipse_1356-2)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1356-4",
    "data-name": "Ellipse 1356",
    cx: 30,
    cy: 29,
    rx: 30,
    ry: 29,
    transform: "translate(-11 70)",
    fill: "url(#linear-gradient-3)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 66, -70.1)",
    filter: "url(#Intersection_7-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Intersection_7-4",
    "data-name": "Intersection 7",
    d: "M0,86C0,38.5,38.052,0,85,0s85,38.5,85,86Z",
    transform: "translate(-66 139)",
    fill: "url(#linear-gradient-3)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.bbe991654ecd5593457c15a8fe29850b.svg";
export { ForwardRef as ReactComponent };